import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { ArrowLeft } from 'lucide-react'
import { Logo } from '../components/Logo'

const divider = (
  <div style={{
    height: '1px',
    background: 'linear-gradient(90deg, transparent 0%, rgba(168,85,247,0.3) 30%, rgba(168,85,247,0.3) 70%, transparent 100%)',
    margin: '28px 0'
  }} />
)

const sections = [
  {
    title: 'Agreement to Terms',
    content: <p style={{ color: '#bbbbbb', lineHeight: 1.8 }}>By accessing and using The Caption Studio, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.</p>
  },
  {
    title: 'Description of Service',
    content: <>
      <p style={{ color: '#bbbbbb', lineHeight: 1.8, marginBottom: '12px' }}>The Caption Studio is a web-based service that uses artificial intelligence to generate captions for your photos. The service includes:</p>
      <ul style={{ color: '#bbbbbb', paddingLeft: '0', listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {['AI-powered image analysis and caption generation', 'Multiple mood and style options', 'Customizable caption preferences', 'Instant caption generation'].map((item, i) => (
          <li key={i} style={{ display: 'flex', gap: '10px' }}><span style={{ color: '#a855f7', flexShrink: 0 }}>▸</span>{item}</li>
        ))}
      </ul>
    </>
  },
  {
    title: 'User Responsibilities',
    content: <>
      <p style={{ color: '#bbbbbb', lineHeight: 1.8, marginBottom: '12px' }}>When using our service, you agree to:</p>
      <ul style={{ color: '#bbbbbb', paddingLeft: '0', listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {['Provide accurate information', 'Use the service only for lawful purposes', 'Not upload images that violate any laws or third-party rights', 'Not attempt to reverse engineer or exploit the service', 'Not use the service to generate harmful or inappropriate content', 'Not abuse or overload our systems'].map((item, i) => (
          <li key={i} style={{ display: 'flex', gap: '10px' }}><span style={{ color: '#a855f7', flexShrink: 0 }}>▸</span>{item}</li>
        ))}
      </ul>
    </>
  },
  {
    title: 'Content Ownership and Rights',
    content: <>
      <h3 style={{ color: '#D1D1F7', fontSize: '1rem', fontWeight: 600, marginBottom: '8px' }}>Your Content</h3>
      <p style={{ color: '#bbbbbb', lineHeight: 1.8, marginBottom: '16px' }}>You retain all ownership rights to the images you upload. By using our service, you grant us a temporary license to process your images solely for the purpose of generating captions.</p>
      <h3 style={{ color: '#D1D1F7', fontSize: '1rem', fontWeight: 600, marginBottom: '8px' }}>Generated Captions</h3>
      <p style={{ color: '#bbbbbb', lineHeight: 1.8, marginBottom: '16px' }}>The captions generated by our AI are provided to you for your use. You are free to use, modify, and publish these captions as you see fit.</p>
      <h3 style={{ color: '#D1D1F7', fontSize: '1rem', fontWeight: 600, marginBottom: '8px' }}>Our Service</h3>
      <p style={{ color: '#bbbbbb', lineHeight: 1.8 }}>All rights, title, and interest in The Caption Studio service, including all intellectual property rights, remain with us.</p>
    </>
  },
  {
    title: 'Prohibited Content',
    content: <>
      <p style={{ color: '#bbbbbb', lineHeight: 1.8, marginBottom: '12px' }}>You may not upload images that contain:</p>
      <ul style={{ color: '#bbbbbb', paddingLeft: '0', listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {['Illegal content or content that promotes illegal activities', 'Hate speech, violence, or discriminatory content', 'Sexually explicit or pornographic material', 'Content that infringes on intellectual property rights', 'Personal information of others without consent', 'Malware, viruses, or harmful code'].map((item, i) => (
          <li key={i} style={{ display: 'flex', gap: '10px' }}><span style={{ color: '#a855f7', flexShrink: 0 }}>▸</span>{item}</li>
        ))}
      </ul>
    </>
  },
  {
    title: 'Disclaimer of Warranties',
    content: <><p style={{ color: '#bbbbbb', lineHeight: 1.8, marginBottom: '12px' }}>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. We do not warrant that the service will meet your requirements, that generated captions will be accurate, or that the service is free from errors or harmful components.</p></>
  },
  {
    title: 'Limitation of Liability',
    content: <>
      <p style={{ color: '#bbbbbb', lineHeight: 1.8, marginBottom: '12px' }}>To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages including:</p>
      <ul style={{ color: '#bbbbbb', paddingLeft: '0', listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {['Loss of profits or revenue', 'Loss of data or content', 'Business interruption', 'Reputational harm from generated content'].map((item, i) => (
          <li key={i} style={{ display: 'flex', gap: '10px' }}><span style={{ color: '#a855f7', flexShrink: 0 }}>▸</span>{item}</li>
        ))}
      </ul>
    </>
  },
  {
    title: 'Governing Law',
    content: <p style={{ color: '#bbbbbb', lineHeight: 1.8 }}>These Terms of Service shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
  },
  {
    title: 'Contact Information',
    content: <p style={{ color: '#bbbbbb', lineHeight: 1.8 }}>
      If you have any questions about these Terms of Service, please contact us at:{' '}
      <a href="mailto:hello.captiostudio@gmail.com"
        style={{ color: '#8E8FFA', textDecoration: 'none' }}
        onMouseEnter={e => (e.currentTarget.style.color = '#e040fb')}
        onMouseLeave={e => (e.currentTarget.style.color = '#8E8FFA')}
      >hello.captiostudio@gmail.com</a>
    </p>
  },
  {
    title: 'Entire Agreement',
    content: <p style={{ color: '#bbbbbb', lineHeight: 1.8 }}>These Terms of Service, together with our Privacy Policy, constitute the entire agreement between you and The Caption Studio regarding the use of our service.</p>
  }
]

export function TermsOfService() {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #050505 0%, #0a0a0f 100%)', fontFamily: "'Space Grotesk', 'Inter', sans-serif" }}>
      <Helmet>
        <title>Terms of Service | The Caption Studio</title>
        <meta name="description" content="Terms of Service for The Caption Studio. Read our usage terms, content guidelines, and service conditions." />
        <link rel="canonical" href="https://thecaption.studio/terms" />
      </Helmet>

      {/* Header */}
      <header style={{ position: 'sticky', top: 0, zIndex: 50, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)', borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '12px 24px' }}>
        <nav style={{ maxWidth: '960px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/"><Logo /></Link>
          <Link to="/"
            style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem', padding: '6px 14px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', transition: 'all 0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.color = '#ffffff'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)'; e.currentTarget.style.boxShadow = '0 0 12px rgba(255,255,255,0.1)' }}
            onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'; e.currentTarget.style.boxShadow = 'none' }}
          >
            <ArrowLeft size={16} /> Back to Home
          </Link>
        </nav>
      </header>

      {/* Content */}
      <main style={{ maxWidth: '960px', margin: '0 auto', padding: '40px 24px' }}>
        <div style={{ background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(15px)', WebkitBackdropFilter: 'blur(15px)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '28px', padding: '50px' }}>

          <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#ffffff', marginBottom: '8px' }}>Terms of Service</h1>
          <p style={{ color: 'rgba(255,255,255,0.35)', marginBottom: '40px', fontSize: '0.9rem' }}>
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          {sections.map((section, i) => (
            <div key={i}>
              <section style={{ marginBottom: '8px' }}>
                <h2 style={{ fontSize: '1.35rem', fontWeight: 600, color: '#ffffff', marginBottom: '14px' }}>{section.title}</h2>
                {section.content}
              </section>
              {i < sections.length - 1 && divider}
            </div>
          ))}

        </div>
      </main>
    </div>
  )
}
